import React, { Component } from 'react'
import { withRouter } from 'next/router'
import dynamic from 'next/dynamic'
import { MdArrowForward } from '@react-icons/all-files/md/MdArrowForward';
import AKLayout from '../layouts/AKLayout';
import ipdata from "../services/ipdata"
import CommonAction from '../actions/CommonAction'
import ScrollCarousel from '../public/js/ScrollCarouselAutoPlay';
import { warn, error } from '../components/Toast';
import Zoom from 'react-medium-image-zoom'
import AKContactForm from '../components/AKContactForm';
// import {ImQuotesLeft} from '@react-icons/all-files/im/ImQuotesLeft';
// import {ImQuotesRight} from '@react-icons/all-files/im/ImQuotesRight';
import FreeConsultationModal from '../components/FreeConsultationModal';
// import TopAdmission from '../components/TopAdmission';
import NewTopAdmits from '../components/NewTopAdmits';
const WhiteCurveSVG = dynamic(() => import('../components/WhiteCurveSVG'));
const AKTestimonialNew = dynamic(() => import('../components/AKTestimonialNew'));
const CustomImage = dynamic(() => import('../components/CustomImage'));

const data = [
    {
        name: 'Akashat Gupta',
        userImg: 'akshat-gupta.png',
        university: 'Duke\'s Fuqua School of Business',
        universityImg: '',
        course: 'Masters in Management',
        comment: 'I highly recommend Adarsh and Parth sir as counselors for anyone seeking guidance in their academic goals. They have been incredibly supportive and dedicated to helping me achieve my goals. Their expertise in the business school application process along with personalized advice was invaluable. They were always available, be it for early-morning application submissions or late-night interview preparations. I was accepted into the Fuqua School of Business and I am grateful for their service.'
    },
    {
        name: "Ananya Gupta",
        userImg: 'ananya-gupta.jpeg',
        university: 'INSEAD',
        universityImg:'',
        course: 'MIM',
        comment: "It has been a great pleasure to work with the team Collegify. Their Career Guidance along with profile building before the applications and constant help with application process and systematic approach to managing the applications deadlines has been impeccable. If you are looking to pursue your masters abroad, I highly recommend team Collegify!"
    },
    {
        name: 'Shreya Tuli',
        userImg: 'shreya-tuli.jpg',
        university: 'Cornell University',
        universityImg:'',
        course: 'Business',
        comment: "The Collegify team's assistance for choosing the right fit with an unbiased, logical, and data-driven approach has been the guiding factor for all my decisions. They made the application process sorted and unchallenging; most of all, they taught me important life lessons and gave me a vision. I'm proud to be continuing the legacy of Collegify of producing Cornell TATA Scholars. I recommend them without reservation, couldn't be more grateful!"
    },
    {
        name: "-Seher’s Mom",
        userImg: 'seher-taneja-mom.jpeg',
        university: 'UPenn Jerome Fisher',
        universityImg:'',
        course: '',
        comment: "My heartfelt gratitude to Team Collegify for standing by our side, guiding us and motivating us throughout this journey. We are overwhelmed by your dedication and effort. Seher has found a true mentor to share all her happiness, fears, and goals with. The team's patient demeanour won her over.God bless Team Collegify."
    },
    {
        name: 'Shaurya Mehta',
        userImg: 'shaurya.png',
        university: 'Stanford University',
        universityImg: '',
        course: 'Economics',
        comment: 'My two year association with Collegify has been wonderful to say the least. Right from taking SAT classes to preparing for my application, I have received unconditional support at every step. Adarsh Sir was extremely supportive. In fact, every member of the team was involved in my application - thus adding new dimensions to my profile & application. I am so happy at my acceptance to Stanford! A DREAM COME TRUE FOR ME! I cannot thank Collegify enough for everything!'
    },
    {
        name: 'Pratyush Sudhakar',
        userImg: 'pratush.png',
        university: 'Cornell University',
        universityImg: '',
        course: 'Computer Science Engineering',
        comment: "Adarsh Sir's work is unparalleled in the industry. Not only me, but my sister Sukriti also got the Tata Scholarship at Cornell. His predictions are absolutely spot-on. My family is very grateful to Adarsh Sir and his incredible team at Collegify."
    },
    {
        name: 'Priyanshi Sharma',
        userImg: 'priyanshi.png',
        university: 'McGill University, Canada',
        universityImg: '',
        course: 'Psychology',
        comment: 'A special thanks to Adarsh Sir and the team of Collegify for guiding me in the right direction – their advice, unique projects, time management techniques and support ensured I got admitted into all the colleges I applied to both in Canada and the UK. I received unexpected scholarships and one offer to join directly from 2nd year!  Along with college admissions, I have gained skills that will prove to be invaluable in college as well.'
    },
    {
        name: 'Aveesha Gandhi',
        userImg: 'Aveesha.jpeg',
        university: 'University Of Chicago',
        universityImg: '',
        course: 'Economics',
        comment: 'For anyone looking for even the smallest amount of guidance in something as challenging and nuanced as applying to your dream university, Collegify has the most insane mentors who provide you with this incredibly personalised college application journey, eliminating all related stress and doubts, to help you reach where you have always envisioned yourself.'
    },
    {
        name: 'Yugam Bajaj',
        userImg: 'Yugam.jpg',
        university: 'London School Of Economics',
        universityImg: '',
        course: 'Masters in Management',
        comment: 'Adarsh Sir helped me stay confident and focused despite challenging circumstances given the pandemic. His constant encouragement and unwavering support played a pivotal role in my admission. Not to mention, his team of mentors did an incredible job in guiding me with my admissions essays.'
    },

]

const layoutData = {
    page: "Adarsh Khandelwal",
    email: "richa@collegify.com",
    mobile: "85058 31919"
}

class AKPage extends Component {

    constructor(props){
        super(props);
        this.state = {
            type: '',
            countryData: [],
            geoLocation: ''
        },
        this.modalRef = React.createRef()
    }

    onClose = () => {
        this.modalRef.current.reset();
    }

    countryFetch = () => {
        CommonAction.listCountry().then((res) => {
            let response = res.data.listCountry;
            if(response.code === "200" && response.status === "success") {
                this.setState( {
                    countryData: response.data.countries
                });
                const getipdataString = localStorage.getItem('user_location_details_local');
                if(!getipdataString) {
                    warn('You have to choose your country manually.');
                }
            }else {
                error('there are some issue on the api side. please reload the page or restart the browser.');
            }
        }).catch((err) => {
            error('there are some issue on the api side. please reload the page or restart the browser.');
        });
    }

    componentDidMount() {
        this.countryFetch();

        ipdata.getLocation().then((res) => {
            if(res) {
                const geoLocation = JSON.parse(localStorage.getItem('user_location_details_local')).geoLocationDetails;
                if(geoLocation) {
                    this.setState({
                        geoLocation
                    });
                }
            }
        }).catch(function(err) {
            console.log(err);
        });

        const carousels = document ? document.querySelectorAll('[data-component="./carousels/ScrollCarouselAutoplayHeading"]') : undefined;
        if(!carousels) return;
        carousels.forEach(carousel => new ScrollCarousel(carousel).init());
    }

    setType = (type) => {
        this.setState({type}, () => {
            if(window.bootstrap) {
            }else {
                window.scrollTo(0, 0);
            }
        })
    }

    componentWillUnmount() {
        this.modalRef?.current?.adarshModal?.hide();
    }

    render() {
        const { type, countryData, geoLocation } = this.state;
        return (
            <AKLayout>
                {/* Hero Bg With Form */}
                <section className="nav-margin ak ak-hero-bg">
                    <div className="py-3 px-3 px-md-0 container">
                        <div className="row justify-content-between align-items-center py-md-5 mb-5">
                            <div className='col-lg-5 d-flex flex-row justify-content-lg-start justify-content-center align-items-center'>
                                <CustomImage srcSetPaths={[{path: `/Others/adarsh-forbes-border.png?tr=w-388,f-avif`, type: 'image/avif'},
                                {path: `/Others/adarsh-forbes-border.png?tr=w-388,f-auto`, type: 'image/webp'}]}
                                mainSrc={`/Others/adarsh-forbes-border.png?tr=w-388,f-png`} alt="" width="388px" imgCDN />
                            </div>
                            <div className='col-lg-7'>
                                <h1 className='mb-2 text-lg-start text-center'>Adarsh Khandelwal </h1>
                                <h4 className='text-wrap' style={{hyphens:"none",textAlign:"justify"}}>
                                    <span style={{fontSize: '38px',fontWeight: 'bold'}}>&ldquo;</span>
                                    With more than a decade of experience, Adarsh has successfully mentored over 10,000 students,
                                    guiding them towards their desired international undergraduate and postgraduate admissions, and scholarships.
                                    In 2018, Adarsh received the Stanford Teacher Tribute for excellent teaching & contribution in the education space.
                                    Adarsh has longstanding business relationships with school boards and extensive networking with top college representatives.
                                    Well-versed with every changing trend, you bet he knows what is going to work for each student.
                                    <span style={{fontSize: '38px',fontWeight: 'bold'}}>&rdquo;</span>
                                </h4>
                            </div>
                        </div>
                    </div>
                    <WhiteCurveSVG />
                </section>
                <section className='container'>
                    <div className='row'>
                        <div className="col-lg-8 mt-md-5">
                            <div
                                className="carousel _mandatory"
                                data-component="./carousels/ScrollCarouselAutoplayHeading"
                                data-autoplay="5000"
                            >
                                {/* <button
                                    className="carousel__ctrl _prev bg-trans"
                                    data-elem-prev-button
                                    tabIndex="-1"
                                    aria-hidden="true"
                                >
                                    <MdChevronLeft fontSize="40px" className='fw-bold' />
                                </button> */}
                                <div className="carousel__track ak-heading" data-elem-carousel-track>
                                    <div className="box _single bg-trans" tabIndex="0">
                                        <div className="pe-md-4" >
                                            <div className="text-center text-lg-start">
                                                <h2 className="fw-600 fs-1 lh-base mb-4">Looking for <i className='text-primary'> Top College Admissions & career planing advice </i> but overwhelmed by the process?</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box _single bg-trans" tabIndex="0">
                                        <div className="pe-md-4" >
                                            <div className="text-center text-lg-start">
                                                <h2 className="fw-600 fs-1 lh-base mb-4">Are <i className='text-primary'> unbiased counselling & a proven track record of success</i> what you seek in your admissions consultant?  </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box _single bg-trans" tabIndex="0">
                                        <div className="pe-md-4" >
                                            <div className="text-center text-lg-start">
                                                <h2 className="fw-600 fs-1 lh-base mb-4">Aiming for the <i className='text-primary'> Ivy Leagues</i>, need guidance with creating <i className='text-primary'>compelling and inspired college essays</i> ?</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box _single bg-trans" tabIndex="0">
                                        <div className="pe-md-4" >
                                            <div className="text-center text-lg-start">
                                                <h2 className="fw-600 fs-1 lh-base mb-4"> Applying for a <i className='text-primary'>full ride scholarship</i>, but wondering how to make your profile stand out?</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box _single bg-trans" tabIndex="0">
                                        <div className="pe-md-5" >
                                            <div className="text-center text-lg-start">
                                                <h2 className="fw-600 fs-1 lh-base mb-4">How can properly structured <i className='text-primary'>  MBA counselling </i> help you crack an M7 or a top Business school?</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <button
                                    className="carousel__ctrl _next bg-trans"
                                    data-elem-next-button
                                    tabIndex="-1"
                                    aria-hidden="true"
                                >
                                    <MdChevronRight fontSize="40px" className='fw-bold' />
                                </button> */}
                            </div>
                        </div>
                        <div className="col-md-8 mx-auto col-lg-4">
                            <div className="card shadow-none bg-primary-light p-4 py-5" id="ak-contact-card" style={{borderRadius: '8px', zIndex: 1, marginTop: '2em'}}>
                                <AKContactForm router={this.props.router} countryData={countryData} locationDetails={geoLocation} />
                            </div>
                        </div>
                    </div>
                </section>
                {/* Test Top Admission */}
                <NewTopAdmits/>
                {/* Top Admissions */}
                {/* <TopAdmission /> */}
                {/* Testimonial Section Caraosel */}
                <AKTestimonialNew list={data} />
                {/* 4th Section */}
                <section className='certificate-section'>
                    <div className="container">
                        <div className="row justify-content-center justify-content-md-between">
                            <div className="col-lg-5 order-1 order-lg-2">
                                <div className="d-flex flex-column flex-md-row mb-4 align-items-center">
                                    {/* <div className="ak-img flex-shrink-0 mb-3 mb-lg-0">
                                        <img src="/favicon.png" alt="adarsh khandelwal"
                                            loading="lazy" width="130" height="130"  />
                                    </div> */}
                                    <h2 className='text-center text-lg-start fw-bold ms-lg-3'>
                                        Why choose <span className="text-primary">Collegify </span> as your Admissions Consultant for Top Colleges Abroad?
                                    </h2>
                                </div>
                                <ul className="blue-dots ms-md-3">
                                    <li>Piloted by Mr. Adarsh Khandelwal, recipient of the Stanford Teacher Tribute for exceptional mentorship in overseas education consulting.</li>

                                    <li>He is regularly featured in leading national dailies for his unique insights and solid advice as one of the country’s top college admission experts.</li>
                                    <li>A vision to fulfil the educational aspirations of students who dream of attending the most prestigious universities across the world.</li>
                                </ul>
                            </div>
                            <div className="col-lg-7 order-2 order-lg-1">
                                <div className="ak-numbers-grid">
                                    <div className="ak-card">
                                        <h3 className='text-primary mb-3'>$40M+</h3>
                                        <p>Million Dollars Scholarship annually, the highest in the country.</p>
                                    </div>
                                    <div className="ak-card">
                                        <h3 className='text-primary mb-3'>400+</h3>
                                        <p>Alumni across top global institutions.</p>
                                    </div>
                                    <div className="ak-card">
                                        <h3 className='text-primary mb-3'>7500+</h3>
                                        <p>Students admitted into competitive UG, PG and MBA programs</p>
                                    </div>
                                    <div className="ak-card">
                                        <h3 className='text-primary mb-3'>100+</h3>
                                        <p>Bespoke hours, preparing students for their study abroad journey.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                {/* 5th Section */}

                <section className="container my-5 pt-5">
                    <h3 className="fw-bold text-center question-wrapper">
                    How will Collegify tailor your <span className="text-primary">Overseas Education Consultation </span> to your specific requirements?
                    </h3>
                    <section className='features mt-5'>
                        <div className='feature'>
                            <svg className='feature-icon'>
                                <use href='/images/AK/illustration.svg#icon-bulb' />
                            </svg>
                            <p className='feature-text fw-600'>We will help you craft your vision so you can create original, inventive, and winning college essays.</p>
                        </div>
                        <div className='feature'>
                            <svg className='feature-icon'>
                                <use href='/images/AK/illustration.svg#icon-hand' />
                            </svg>
                            <p className='feature-text'>
                            Thorough end-to-end guidance for college mapping and finding the study destination that suits you best.
                            </p>
                        </div>
                        <div className='feature'>
                            <svg className='feature-icon'>
                                <use href='/images/AK/illustration.svg#icon-scholar' />
                            </svg>
                            <p className='feature-text'>Together, we’ll explore and assess the various scholarship programs available so you can find your perfect fit.</p>
                        </div>
                        <div className='feature'>
                            <svg className='feature-icon'>
                                <use href='/images/AK/illustration.svg#icon-topic' />
                            </svg>
                            <p className='feature-text'> We’re equipped to help you plan your standardized tests and prepare for them in a structured way.</p>
                        </div>
                        <div className='feature'>
                            <svg className='feature-icon'>
                                <use href='/images/AK/illustration.svg#icon-mock' />
                            </svg>
                            <p className='feature-text'>
                            We are passionate about leveraging the standout factors that set you apart from other university applicants.
                            </p>
                        </div>
                        <div className='feature'>
                            <svg className='feature-icon'>
                                <use href='/images/AK/illustration.svg#icon-video' />
                            </svg>
                            <p className='feature-text'>We are committed to spending 100+ hours in bespoke sessions with you, leaving no stone unturned for your international college journey.</p>
                        </div>
                    </section>

                </section>


                {/* Media Coverage */}
                <section className="media-coverage">
                    <div className="py-3 px-3 px-md-0 container text-center">
                        <h2 className="text-primary fw-bold">Media Highlights</h2>
                        <div className='colored-line line-center'></div>
                        <h4 className="fw-600 mb-5">Content contributor in Economic Times, India Today, The Hindu, Business Standard etc.</h4>
                        <div className="media-article-grid">
                            <Zoom>
                                <CustomImage srcSetPaths={[{path: '/admission/media-article-1.jpg?tr=w-350,f-avif', type: 'image/avif'},{path: '/admission/media-article-1.jpg?tr=w-350,f-auto', type: 'image/webp'}]}
                                    mainSrc="/admission/media-article-1.jpg?tr=w-350,f-png"  alt="Collegify on SME WORLD" width="100%" height="auto" imgCDN />

                            </Zoom>

                            <Zoom>
                                <CustomImage srcSetPaths={[{path: '/admission/media-article-2.jpg?tr=w-350,f-avif', type: 'image/avif'},{path: '/admission/media-article-2.jpg?tr=w-350,f-auto', type: 'image/webp'}]}
                                    mainSrc="/admission/media-article-2.jpg?tr=w-350,f-png"  alt="Collegify on Inida Today news" width="100%" height="auto" imgCDN />

                            </Zoom>
                            <Zoom>
                                <CustomImage srcSetPaths={[{path: '/admission/media-article-3.png?tr=w-350,f-avif', type: 'image/avif'},{path: '/admission/media-article-3.png?tr=w-350,f-auto', type: 'image/webp'}]}
                                    mainSrc="/admission/media-article-3.png?tr=w-350,f-png"  alt="Collegify on The Economic Times" width="100%" height="auto" imgCDN />

                            </Zoom>
                            <Zoom>
                            <CustomImage srcSetPaths={[{path: '/admission/media-article-4.jpeg?tr=w-350,f-avif', type: 'image/avif'},{path: '/admission/media-article-4.jpeg?tr=w-350,f-auto', type: 'image/webp'}]}
                                    mainSrc="/admission/media-article-4.jpeg?tr=w-350,f-png"  alt="Adarsh Khandelwal on The Economic Times" width="100%" height="auto" imgCDN />

                            </Zoom>
                            <Zoom>
                                <CustomImage srcSetPaths={[{path: '/admission/media-article-5.jpg?tr=w-350,f-avif', type: 'image/avif'},{path: '/admission/media-article-5.jpg?tr=w-350,f-auto', type: 'image/webp'}]}
                                    mainSrc="/admission/media-article-5.jpg?tr=w-350,f-png"  alt="Collegify on Times now" width="100%" height="auto" imgCDN />

                            </Zoom>
                        </div>
                    </div>
                </section>

                {/* Contact Us Section only Mobile */}
                <section className="d-md-none my-5">
                    <div className="container d-flex flex-column justify-content-center">
                        <h3 className='text-center text-primary fw-bold mb-4'>Contact Us</h3>
                        <a href={`mailto:${layoutData.email}?subject=Contacting for admission`} className="d-flex justify-content-start text-body align-items-center mb-3">
                            <CustomImage srcSetPaths={[{path: '/admission/mail-icon.png?tr=w-20,f-avif', type: 'image/avif'},{path: '/admission/mail-icon.png?tr=w-20,f-auto', type: 'image/webp'}]}
                                mainSrc="/admission/mail-icon.png?tr=w-20,f-png" alt="Mail Icon" className="me-2"
                                width="20px" height="auto" imgCDN loading="lazy" />
                            <h5 className="mb-0 text-body">{layoutData.email}</h5>
                        </a>
                        <a href="tel:850-583-1919" className="d-flex justify-content-start align-items-center mb-0">
                            <CustomImage srcSetPaths={[{path: '/admission/phone-icon.png?tr=w-20,f-avif', type: 'image/avif'},{path: '/admission/phone-icon.png?tr=w-20,f-auto', type: 'image/webp'}]}
                                mainSrc="/admission/phone-icon.png?tr=w-20,f-png" alt="phone icon" className="me-2"
                                width="20px" height="auto" imgCDN loading="lazy" />
                            <h5 className="mb-0 text-body">+91 {layoutData.mobile}</h5>
                        </a>
                    </div>
                </section>
                <section className='career-mapping-section'>
                    <div className="career-mapping-cta">
                        <h3 className="text-primary fw-bold mb-4">Book a Career Mapping Session with Adarsh Khandelwal</h3>
                        <button type="button" className='btn btn-secondary bg-white btn-with-icon btn-text-revert mx-auto' data-bs-toggle="modal" data-bs-target="#AdarshModal" onClick={this.setType.bind(this, 'booking')}>
                            Book Now
                            <span className="btn-icon md bg-yellow"><MdArrowForward /></span>
                        </button>
                    </div>
                </section>
                {/* Modal Trigger Form */}
                <div className="modal fade" id="AdarshModal" tabIndex="-1" aria-labelledby="contactAdarshLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="contactAdarshLabel">Book a call with Adarsh</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.onClose}></button>
                            </div>
                            <div className="modal-body px-5 py-4">
                                <AKContactForm formId="AdarshModal-form" ref={this.modalRef} type={type} router={this.props.router}
                                    countryData={countryData} locationDetails={geoLocation}/>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Modal Trigger Form */}
                <FreeConsultationModal slackChannel="adarsh-landing-pg-leads"/>
            </AKLayout>
        )
    }
}

export default withRouter(AKPage);
